import { render, staticRenderFns } from "./JoinerModal.vue?vue&type=template&id=b5b34622&scoped=true&"
import script from "./JoinerModal.vue?vue&type=script&lang=js&"
export * from "./JoinerModal.vue?vue&type=script&lang=js&"
import style0 from "./JoinerModal.vue?vue&type=style&index=0&id=b5b34622&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b34622",
  null
  
)

export default component.exports